// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","HeightSMMax":"(max-height: 639px)","pageContainer":"G8270b2","headerContainer":"G5a709e"};